window._iconfont_svg_string_4198374 = '<svg><symbol id="icon-right_arrow" viewBox="0 0 1024 1024"><path d="M761.6 489.6l-432-435.2c-9.6-9.6-25.6-9.6-35.2 0-9.6 9.6-9.6 25.6 0 35.2l416 416-416 425.6c-9.6 9.6-9.6 25.6 0 35.2s25.6 9.6 35.2 0l432-441.6C771.2 515.2 771.2 499.2 761.6 489.6z"  ></path></symbol><symbol id="icon-left_arrow" viewBox="0 0 1024 1024"><path d="M729.6 931.2l-416-425.6 416-416c9.6-9.6 9.6-25.6 0-35.2-9.6-9.6-25.6-9.6-35.2 0l-432 435.2c-9.6 9.6-9.6 25.6 0 35.2l432 441.6c9.6 9.6 25.6 9.6 35.2 0C739.2 956.8 739.2 940.8 729.6 931.2z"  ></path></symbol></svg>', function (n) {
  var t = (t = document.getElementsByTagName("script"))[t.length - 1], e = t.getAttribute("data-injectcss"),
    t = t.getAttribute("data-disable-injectsvg");
  if (!t) {
    var o, i, c, d, s, a = function (t, e) {
      e.parentNode.insertBefore(t, e)
    };
    if (e && !n.__iconfont__svg__cssinject__) {
      n.__iconfont__svg__cssinject__ = !0;
      try {
        document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>")
      } catch (t) {
        console && console.log(t)
      }
    }
    o = function () {
      var t, e = document.createElement("div");
      e.innerHTML = n._iconfont_svg_string_4198374, (e = e.getElementsByTagName("svg")[0]) && (e.setAttribute("aria-hidden", "true"), e.style.position = "absolute", e.style.width = 0, e.style.height = 0, e.style.overflow = "hidden", e = e, (t = document.body).firstChild ? a(e, t.firstChild) : t.appendChild(e))
    }, document.addEventListener ? ~["complete", "loaded", "interactive"].indexOf(document.readyState) ? setTimeout(o, 0) : (i = function () {
      document.removeEventListener("DOMContentLoaded", i, !1), o()
    }, document.addEventListener("DOMContentLoaded", i, !1)) : document.attachEvent && (c = o, d = n.document, s = !1, r(), d.onreadystatechange = function () {
      "complete" == d.readyState && (d.onreadystatechange = null, l())
    })
  }

  function l() {
    s || (s = !0, c())
  }

  function r() {
    try {
      d.documentElement.doScroll("left")
    } catch (t) {
      return void setTimeout(r, 50)
    }
    l()
  }
}(window);